module.exports = __webpack_public_path__ + "static/media/HomeServiceBackArrow.48e08c7b.svg";